import {apiClient} from "@/service/ApiClient";

export interface BoardData{
    boardNo: number,
    title: string,
    content: string,
    writerId: number,
    regDt: string,
    updateDt: string,
    writerNickName:string,
}

export interface BoardItem{
    title:string,
    content:string,
    writerId:number
}

const getBoardList = async () =>
    apiClient.get<BoardData[]>("/board/list").then(res =>res.data)

const postBoard = async (board: BoardItem | undefined) =>
    apiClient.post<BoardData>("/board", {...board}).then(res=>res.data)

const updateBoard = async (board: BoardItem, boardNo: number) =>
    apiClient.patch("/board/" + boardNo.toString(), {...board})

const BoardService = {
    getBoardList,
    postBoard,
    updateBoard
}

export default BoardService